import styled from 'styled-components';

import { themeVariants } from 'style-utils/theme';
import {
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  TypographyProps as StyledTypographyProps,
  system,
  typography,
} from 'styled-system';
import {
  body,
  bodyCaption,
  bodyCaptionBold,
  bodyLead,
  bodyLeadBold,
  bodyMicroCaption,
  displayD1,
  displayD2,
  displayH1,
  displayH2,
  displayH3,
} from './typography.config';

type TypographyProps = LayoutProps &
  SpaceProps &
  FlexboxProps &
  PositionProps &
  ColorProps &
  StyledTypographyProps & {
    variant?:
      | 'displayD1'
      | 'displayD2'
      | 'displayH1'
      | 'displayH2'
      | 'displayH3'
      | 'bodyLead'
      | 'bodyLeadBold'
      | 'body'
      | 'bodyCaption'
      | 'bodyCaptionBold'
      | 'bodyMicroCaption';
    cursor?: string;
    textDecoration?: string;
  };

const extraProperties = system({
  cursor: {
    property: 'cursor',
  },
  textDecoration: {
    property: 'textDecoration',
  },
});

const typographyVariant = themeVariants('vendor', 'variant', {
  displayD1: {
    pokerstars: displayD1,
  },
  displayD2: {
    pokerstars: displayD2,
  },
  displayH1: {
    pokerstars: displayH1,
  },
  displayH2: {
    pokerstars: displayH2,
  },
  displayH3: {
    pokerstars: displayH3,
  },
  bodyLead: {
    pokerstars: bodyLead,
  },
  bodyLeadBold: {
    pokerstars: bodyLeadBold,
  },
  body: {
    pokerstars: body,
  },
  bodyCaption: {
    pokerstars: bodyCaption,
  },
  bodyCaptionBold: {
    pokerstars: bodyCaptionBold,
  },
  bodyMicroCaption: {
    pokerstars: bodyMicroCaption,
  },
});

export const Typography = styled.span<TypographyProps>`
  ${extraProperties}
  ${typographyVariant}
  ${layout}
  ${space}
  ${flexbox}
  ${position}
  ${typography}
  ${color}
`;

export type { TypographyProps };
